import { apiClient } from "./api";

// Client-facing email + password auth. Cookies flow automatically via the shared
// axios instance (withCredentials=true), so nothing extra to do per request.
// Session cookie name: `client_session` (separate from the coach's `session_token`).

export async function clientSignup({ full_name, preferred_name, email, password }) {
  const { data } = await apiClient.post("/client-auth/signup", { full_name, preferred_name, email, password });
  return data;
}

export async function clientLogin({ email, password }) {
  const { data } = await apiClient.post("/client-auth/login", { email, password });
  return data;
}

export async function clientLogout() {
  const { data } = await apiClient.post("/client-auth/logout");
  return data;
}

export async function clientMe() {
  const { data } = await apiClient.get("/client-auth/me");
  return data;
}

export async function clientRequestReset(email) {
  const { data } = await apiClient.post("/client-auth/password-reset-request", { email });
  return data;
}

export async function clientConfirmReset(token, new_password) {
  const { data } = await apiClient.post("/client-auth/password-reset-confirm", { token, new_password });
  return data;
}
